import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Text from '../../components/Text'

const Message = styled.div`
  font-weight: 300;
  font-size: 1.5rem;
  text-align: center;
`

export default class Step4 extends Component {
  render() {
    return (
      <Card>
        <Card.Pad>
          <Message>
            <Text str="titles.accountCreated" />
          </Message>
        </Card.Pad>
        <Card.Divider />
        <Card.Pad>
          <Button
            to="/"
            color="blue"
            str="titles.backToLogin"
          />
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SignUp/Step4.js